/* This is the EMIS Pre student and ethnic components */

<template>
  <v-container>
    <div>
      <span v-html="title + ' ' + curacc + ' ' + ctitle"></span>
    </div>
    <table style="width: 709px; height: 77px" border="1px;" cellspacing="0px;">
      <tbody>
        <tr style="height: 29px">
          <td
            style="
              width: 100px;
              height: 54px;
              text-align: center;
              vertical-align: middle;
            "
            rowspan="2"
          >
            សិស្សភៀសសឹក
          </td>
          <td
            style="
              width: 60px;
              height: 29px;
              text-align: center;
              vertical-align: middle;
            "
            colspan="2"
          >
            ថ្នាក់កម្រិតទាប
          </td>
          <td
            style="
              width: 60px;
              height: 29px;
              text-align: center;
              vertical-align: middle;
            "
            colspan="2"
          >
            ថ្នាក់កម្រិតមធ្យម
          </td>
          <td
            style="
              width: 60px;
              height: 29px;
              text-align: center;
              vertical-align: middle;
            "
            colspan="2"
          >
            ថ្នាក់កម្រិតខ្ពស់
          </td>
          <td
            style="
              width: 60px;
              height: 29px;
              text-align: center;
              vertical-align: middle;
            "
            colspan="2"
          >
            ថ្នាក់ចម្រុះ
          </td>
          <td
            style="
              width: 60px;
              height: 29px;
              text-align: center;
              vertical-align: middle;
            "
            colspan="2"
          >
            សរុប
          </td>
        </tr>
        <tr style="height: 25px">
          <td class="td-white">សរុប</td>
          <td class="td-white">ស្រី</td>
          <td class="td-white">សរុប</td>
          <td class="td-white">ស្រី</td>
          <td class="td-white">សរុប</td>
          <td class="td-white">ស្រី</td>
          <td class="td-white">សរុប</td>
          <td class="td-white">ស្រី</td>
          <td class="td-white">សរុប</td>
          <td class="td-white">ស្រី</td>
        </tr>
        <!-- Data Row -->
        <tr
          v-for="(value, row) in preMig.length"          
          :key="row"
          style="height: 25px"
        >
          <td
            style="
              width: 100px;
              height: 25px;
              text-align: center;
              vertical-align: middle;
            "
          >
            {{ preMig[row] }}
          </td>
          <td class="td-white">
            <numberinput
              v-model="data[row].dt[0]"              
              class="number"
            />
          </td>
          <td class="td-white">
            <numberinput
              v-model="data[row].dt[1]"              
              class="number"
            />
          </td>
          <td class="td-white">
            <numberinput
              v-model="data[row].dt[2]"              
              class="number"
            />
          </td>
          <td class="td-white">
            <numberinput
              v-model="data[row].dt[3]"              
              class="number"
            />
          </td>
          <td class="td-white">
            <numberinput
              v-model="data[row].dt[4]"              
              class="number"
            />
          </td>
          <td class="td-white">
            <numberinput
              v-model="data[row].dt[5]"              
              class="number"
            />
          </td>
          <td class="td-white">
            <numberinput
              v-model="data[row].dt[6]"              
              class="number"
            />
          </td>
          <td class="td-white">
            <numberinput
              v-model="data[row].dt[7]"              
              class="number"
            />
          </td>
          <td class="td-white">
            <strong>{{ col1[row] | blank }}</strong>
          </td>
          <td class="td-white">
            <strong>{{ col2[row] | blank }}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { preMig} from "@/utils/ascf/preConfig.js";
export default {
  props: ["data", "curacc", "title", "ctitle"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      preMig: preMig      
    };
  },
  computed: {
    /* col1 and col2 are compute function in each row by age and total/gender */
    col1: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col2: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.td-white {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: white;
}
.td-light {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.td-white-long {
  width: 250px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
  background-color: white;
}
.td-light-long {
  width: 250px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
  background-color: lightgray;
}
</style>